export const mapKeys = <T extends object>(
  object: T,
  transformFn: (key: Extract<keyof T, string>) => PropertyKey
) => {
  const keys = Object.keys(object) as Extract<keyof T, string>[];
  return keys.reduce<Record<PropertyKey, T[keyof T]>>((acc, cur) => {
    return {
      ...acc,
      [transformFn(cur)]: object[cur],
    };
  }, {});
};
